export class FixedPoints {
  static thomasJeffersonHighSchool = {
    pixCoord: {
      x: 1312,
      y: 163.5,
    },
    lat: 37.57220618,
    lon: -77.48568445,
  };
  static rocketsLandingMarina = {
    pixCoord: {
      x: 7025,
      y: 5930,
    },
    lat: 37.51689338,
    lon: -77.4165746,
  };
}
